
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

@Component
export default class TextInput extends Vue {
  @Prop()
  value: unknown;
  @Prop()
  inputOptions!: HTMLInputElement; // we should get rid of the input options... they're never used

  @Prop()
  rules!: ((v: string) => string)[];
  @Prop()
  testId!: string;
  @Prop({ default: true })
  clearable!: boolean;

  get isNumber() {
    return this.inputOptions?.type === "number";
  }
  edit(newVal: unknown) {
    if (this.isNumber && newVal) {
      this.$emit("input", parseFloat(newVal as string));
    } else {
      this.$emit("input", newVal);
    }
  }
}
